import BrandRegistrationPendingDialog from "./BrandRegistrationPendingDialog"
import RegisterA2P10DLCDialog from "./RegisterA2P10DLCDialog"

export default function RegisterA2P10DLCDialogCombo({
  registerA2P10DLCDialogOpen,
  handleRegisterA2P10DLCDialogClosed,
  brandRegistrationPendingDialogOpen,
  setBrandRegistrationPendingDialogOpen,
}) {
  return (
    <>
      <RegisterA2P10DLCDialog
        open={registerA2P10DLCDialogOpen}
        onClose={handleRegisterA2P10DLCDialogClosed}
      />
      <BrandRegistrationPendingDialog
        open={brandRegistrationPendingDialogOpen}
        onClose={() => setBrandRegistrationPendingDialogOpen(false)}
      />
    </>
  )
}
